// All settings related apis
import instance, { API_URL } from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching tax rate's details for the active organization
export const fetchTaxRate = async (organizationId) => {
  const oId = encryptData(organizationId);
  return await instance.get(`${API_URL}/organizations/${oId}/tax-rate`);
};

// Post api for updating the active organization's tax rate's details
export const setTaxRate = async (organizationId, rate) => {
  const oId = encryptData(organizationId);
  return await instance.post(`${API_URL}/organizations/${oId}/tax-rate`, rate);
};
